import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { stockService } from "../../services/stockService";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import { SetStockAdjustmentEdit } from "../../store/stockAdjustmentAtom";
import { Dropdown } from 'react-bootstrap';
import UserDeliverySideBar from "./UserDeliverySideBar";
import { driverAssignService } from "../../services/driverAssignService";


const UserDeliveryAppDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setStockEdit = SetStockAdjustmentEdit();
  const [isToggling, setIsToggling] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [userData, setUserData] = useState({
    user_info: [],
    action_status: [],
  });

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "User Delivery App Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);


  const loadDetailsData = () => {
    driverAssignService.driverAppUserDetails(id).then((response) => {
      const serverData = toLowercaseKeys(response.data);
      console.log('serverData', serverData);
      if (serverData) {
        setUserData(serverData);
      }
    });
  }

  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Adjustment",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (response.decision === true) {
      setStockEdit(userData);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };


  async function bulkActionsSingle(action) {
    const option = action.action_option;
    const result = await myPromiseModal({
      title: 'confirm your action!',
      body: `Do you want to ${action.status_name} ?`,
      showInput: false,
      placeHolder: '',
    });
    if (result.decision === false) {
      return;
    }

    try {
      const payload = { option: option, ref_no: id }
      const res = await stockService.stockAdjustmentAction(payload);
      const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        logicContext.showToast(response.message_text || 'Stock adjustment saved successfully!', 'success');
        loadDetailsData();
      } else {
        logicContext.showToast(response.message_text || 'Failed to save', 'error');
      }


    } catch (error) {
      console.log("error", error);



    }




  }


  const changeDriverStatus = async (statusName) => {
    const currentStatus = statusName.status_name;
    let option = 2;
    let modalMessage = '';
    if (currentStatus === 'Active') {
      option = 3 // make inactive;
      modalMessage = 'Change status to InActive'
    }

    if (currentStatus === 'Inactive') {
      option = 2 // make inactive;
      modalMessage = 'Change status to Active'
    }

    const result = await myPromiseModal({
      title: 'confirm your action!',
      body: `${modalMessage}`,
      showInput: false,
      placeHolder: '',
    });
    if (result.decision === false) {
      return;
    }

    try {
      // "option":2= active/ 3 -inactive, user_id
      const payload = { option: option, delivery_user_id: id }
      const res = await driverAssignService.changeStatusDeliveryAppUser(payload);
      const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        logicContext.showToast(response.message_text || 'Status updated successfully!', 'success');
        loadDetailsData();
      } else {
        logicContext.showToast(response.message_text || 'Failed to update status', 'error');
      }


    } catch (error) {
      console.log("error", error);



    }




  }

  const handleToggleChange = async () => {
    if (isToggling) return; // Prevent multiple clicks

    const currentStatus = userData?.user_info?.[0]?.driver_app_access_status_name;
    // const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';

    setIsToggling(true);

    try {
      await changeDriverStatus({ status_name: currentStatus });
    } finally {
      setIsToggling(false);
    }
  };




  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `User_Details_${userData?.user_info?.[0]?.user_full_name}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const getStatusColor = (statusName) => {
    switch (statusName) {
      case "Active":
        return "bg-emerald-100 text-emerald-700 border-emerald-200";
      case "Inactive":
        return "bg-rose-100 text-rose-700 border-rose-200";
      case "Pending":
        return "bg-amber-100 text-amber-700 border-amber-200";
      default:
        return "bg-slate-100 text-slate-700 border-slate-200";
    }
  };

  const viewItemDetails = useCallback(
    adId => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
    },
    [currModuleId, currModuleName, navigate]
  );

  const isDriverActive = userData?.user_info?.[0]?.driver_app_access_status_name === 'Active';

  return (
    <section className="mt-4 w-full mx-auto px-4 sm:px-6 lg:px-8">


      <div className="flex justify-end gap-3 mb-6">
        {userData?.action_status?.length > 0 &&
          <Dropdown>
            <Dropdown.Toggle
              className="text-sm text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg transition-all duration-200 shadow-md flex items-center gap-2"
              id="dropdown-basic"
            >
              ACTIONS
            </Dropdown.Toggle>
            <Dropdown.Menu className="mt-2 shadow-2xl border-none rounded-xl bg-white/95 backdrop-blur-sm overflow-hidden py-0">
              {userData?.action_status?.map((option, i) => (
                <Dropdown.Item key={i} onClick={() => bulkActionsSingle(option)} className="hover:bg-blue-50 py-2.5 px-4 text-gray-700 text-sm border-b border-gray-50 last:border-0 transition-colors">
                  {option?.status_name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        }

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          <img src={printer} alt="Print" className="w-5 h-5" />
          <span className="hidden sm:inline">Print</span>
        </button>

        <button
          onClick={editCurrentData}
          className="p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition"
          title="Edit"
        >
          <img src={pencil} alt="Edit" className="w-6 h-6" />
        </button>

        <button
          // onClick={deleteCurrentData}  ← uncomment when delete logic is ready
          className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition opacity-50 cursor-not-allowed"
          title="Delete (not implemented)"
        >
          <img src={trash} alt="Delete" className="w-6 h-6" />
        </button>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Sidebar - Scroll List */}
        <div className="">
          <UserDeliverySideBar onSelection={onSelection} viewItemDetails={viewItemDetails} />
        </div>

        {/* Main Details Card - PRINTABLE AREA */}
        <div ref={printRef} className="flex-1">
          <div className="bg-white shadow-2xl rounded-2xl overflow-hidden border border-gray-100">
            {/* Stylish Header Banner */}
            <div className="h-32 bg-gradient-to-r from-blue-600 to-blue-500 relative">
              <div className="absolute -bottom-12 left-8 flex items-end gap-6">
                <div className="w-24 h-24 bg-white rounded-2xl shadow-lg flex items-center justify-center p-1">
                  <div className="w-full h-full bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                    <span className="text-3xl font-bold">
                      {userData?.user_info?.[0]?.user_full_name?.charAt(0) || "U"}
                    </span>
                  </div>
                </div>
                <div className="mb-2">
                  <h1 className="text-2xl font-bold text-white drop-shadow-md mb-4">
                    {userData?.user_info?.[0]?.user_full_name || "User Details"}
                  </h1>
                  <div className="flex items-center gap-2 text-blue-100 text-sm mt-1 font-medium">
                    <span className="px-2 py-0.5 bg-white/20 rounded-md backdrop-blur-sm">
                      ID: {userData?.user_info?.[0]?.user_id || "—"}
                    </span>
                    <span className={`px-2 py-0.5 rounded-md border backdrop-blur-sm ${getStatusColor(userData?.user_info?.[0]?.user_status_name)}`}>
                      {userData?.user_info?.[0]?.user_status_name || "Unknown"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-8 pt-16">
              {/* Info Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Contact Information Section */}
                <div className="bg-gray-50/50 p-6 rounded-2xl border border-gray-100">
                  <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 flex items-center gap-2">
                    <i className="fas fa-address-card text-blue-400"></i> Contact Information
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Email Address</p>
                      <p className="font-semibold text-gray-800 break-all">{userData?.user_info?.[0]?.user_email_address || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Mobile Number</p>
                      <p className="font-semibold text-gray-800">{userData?.user_info?.[0]?.user_mobile_number || "—"}</p>
                    </div>
                  </div>
                </div>

                {/* App Access Section */}
                <div className="bg-gray-50/50 p-6 rounded-2xl border border-gray-100">
                  <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 flex items-center gap-2">
                    <i className="fas fa-key text-blue-400"></i> App Access Details
                  </h3>
                  <div className="space-y-4">
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Driver App Access Status</p>
                      <div className="flex items-center gap-3 mt-2">
                        {/* Toggle Switch */}
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={isDriverActive}
                            onChange={handleToggleChange}
                            disabled={isToggling}
                          />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500"></div>
                        </label>
                        <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${isDriverActive
                          ? 'bg-emerald-500 text-white'
                          : 'bg-slate-400 text-white'
                          }`}>
                          {userData?.user_info?.[0]?.driver_app_access_status_name || "—"}
                        </span>
                        {isToggling && (
                          <div className="flex items-center gap-2 text-xs text-gray-500">
                            <svg className="animate-spin h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Updating...
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Activation Date</p>
                      <p className="font-semibold text-gray-800">
                        {userData?.user_info?.[0]?.activation_date ? new Date(userData?.user_info?.[0]?.activation_date).toLocaleDateString() : "—"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* System Logs Section */}
                <div className="md:col-span-2 bg-slate-50 p-6 rounded-2xl border border-dashed border-slate-200">
                  <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4">System Metadata</h3>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Created By</p>
                      <p className="text-sm font-semibold text-gray-700">{userData?.user_info?.[0]?.created_user_name || "System"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Last Modified</p>
                      <p className="text-sm font-semibold text-gray-700">
                        {userData?.user_info?.[0]?.last_modified_date
                          ? new Date(userData?.user_info?.[0]?.last_modified_date).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                          : "—"}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Last Changed By</p>
                      <p className="text-sm font-semibold text-gray-700">{userData?.user_info?.[0]?.last_changed_user_name || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Last Modified Date</p>
                      <p className="text-sm font-semibold text-gray-700">
                        {userData?.user_info?.[0]?.last_modified_date
                          ? new Date(userData?.user_info?.[0]?.last_modified_date).toLocaleDateString()
                          : "—"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserDeliveryAppDetailsPage;